// extracted by mini-css-extract-plugin
export var passResetText = "pass-request-reset-module--pass-reset-text--hTdIB";